<template>
	<v-card :elevation="1" class="flex round-card background-2" style="white-space: nowrap">
        <v-card-title class="pa-3">
			<p class="pl-2 pl-xl-3">Stato degli Ordini</p>
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                        <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                    </v-btn>
                </template>                    
                <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
            </v-tooltip>
        </v-card-title>            
        <v-divider v-if="expand"></v-divider>

        <v-expand-transition>

            <div v-show="expand" id="ordersstatus" class="px-2" ref="ordersstatus" style="height: 450px">
            </div>

        </v-expand-transition>

    </v-card>

</template>
<script>

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themes_dark from '@amcharts/amcharts4/.internal/themes/dark'
    import am4themes_material from '@amcharts/amcharts4/themes/material'
    import am4themes_animated from "@amcharts/amcharts4/themes/animated"
    
    am4core.useTheme(am4themes_animated)

    export default {
        name: 'orders-status',
        props: {

        },

        data() {
            return {
                orders: [],
                expand: JSON.parse(localStorage.getItem('my_orders_status_'+this.$store.getters.getProfile.id)),
                loading: false,
                chart: {},
            }
        },

        watch: {
            expand: {
                handler(newValue, oldValue) {
                    if(newValue == true) {
                        this.initialize()
                    } else {
                        localStorage.setItem('my_orders_status_'+this.$store.getters.getProfile.id, JSON.stringify(false))
                    }
                },
                immediate: true
            },

            '$vuetify.theme.dark' (newVal) {
                if(newVal) {
                    am4core.useTheme(am4themes_dark)
                    this.initialize()
                } else {
                    am4core.unuseTheme(am4themes_dark)
                    this.initialize()
                }
            }
        },
    

        methods: {

            initialize() {
                this.loading = true
                this.axios.post('myorders').then(response => {
                    if (this._isBeingDestroyed || this._isDestroyed) return
                    this.orders = response.data.data

                    if (!_.isEmpty(this.chart)) {
                        this.chart.dispose()
                    }
                    this.loading = false

                    this.chart = am4core.create(this.$refs.ordersstatus, am4charts.RadarChart)
                    this.chart.data = this.orders
                    // Make chart not full circle
                    this.chart.startAngle = -90
                    this.chart.endAngle = 180
                    this.chart.fontSize = 11
                    this.chart.innerRadius = am4core.percent(27)

                    // Set number format
                    this.chart.numberFormatter.numberFormat = "#.#'%'"

                    // Create axes
                    let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
                    categoryAxis.dataFields.category = "status_text"
                    categoryAxis.renderer.grid.template.location = 0
                    categoryAxis.renderer.grid.template.strokeOpacity = 0
                    categoryAxis.renderer.labels.template.horizontalCenter = 'right'
                    categoryAxis.renderer.labels.template.fontWeight = 500
                    categoryAxis.renderer.labels.template.fontSize = 12
                    categoryAxis.renderer.labels.template.adapter.add("fill", (fill, target) => {
                        return (target.dataItem.index >= 0) ? this.chart.colors.getIndex(target.dataItem.index) : fill
                    })
                    categoryAxis.renderer.minGridDistance = 10

                    let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
                    valueAxis.renderer.grid.template.strokeOpacity = 0
                    valueAxis.min = 0
                    valueAxis.max = 100
                    valueAxis.strictMinMax = true


                    var centerLabel1 = this.chart.radarContainer.createChild(am4core.Label)
                    centerLabel1.fontSize = 12
                    centerLabel1.horizontalCenter = 'middle'
                    centerLabel1.verticalCenter = 'middle'
                    centerLabel1.dy = -15
                    centerLabel1.text = 'Totale'
                    centerLabel1.fill = am4core.color('#00E676')

                    var centerLabel2 = this.chart.radarContainer.createChild(am4core.Label)
                    centerLabel2.fontSize = 24
                    centerLabel2.horizontalCenter = 'middle'
                    centerLabel2.marginTop = 0
                    centerLabel2.dy = -10
                    centerLabel2.text = "[bold]"+ this.orders[0].full + "[/]"
                    centerLabel2.fill = am4core.color('#00E676')
                            
                    var series1 = this.chart.series.push(new am4charts.RadarColumnSeries());
                    series1.dataFields.valueX = 'full'
                    series1.dataFields.categoryY = "status_text";
                    series1.clustered = false;
                    series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
                    series1.columns.template.fillOpacity = 0.08;
                    series1.columns.template.cornerRadiusTopLeft = 20;
                    series1.columns.template.strokeWidth = 0;
                    series1.columns.template.radarColumn.cornerRadius = 20;

                    let series2 = this.chart.series.push(new am4charts.RadarColumnSeries())
                    series2.dataFields.valueX = 'percentage'
                    series2.dataFields.categoryY = 'status_text'
                    series2.clustered = false
                    series2.columns.template.strokeWidth = 0
                    series2.columns.template.tooltipText = "[font-size: 12px]{status_text}: {percentage}% ({value.formatNumber('#.#')})"
                    series2.columns.template.radarColumn.cornerRadius = 20

                    series2.columns.template.adapter.add("fill", (fill, target) => {
                        return this.chart.colors.getIndex(target.dataItem.index)
                    })

                    series2.columns.template.events.on("over", (ev) => {
                        centerLabel1.dataItem = ev.target.dataItem
                        centerLabel2.dataItem = ev.target.dataItem
                        centerLabel1.text = '{status_text}'
                        centerLabel2.text = "[bold]{value.formatNumber('#.#')}[/]"
                        centerLabel1.fill = this.chart.colors.getIndex(ev.target.dataItem.index)
                        centerLabel2.fill = this.chart.colors.getIndex(ev.target.dataItem.index)
                    })                
    
                    series2.columns.template.events.on("out", (ev) => {
                        centerLabel1.dataItem = ev.target.dataItem
                        centerLabel2.dataItem = ev.target.dataItem                        
                        centerLabel1.text = 'Totale'
                        centerLabel2.text = "[bold]{full.formatNumber('#.#')}[/]"
                        centerLabel1.fill = am4core.color('#00E676')
                        centerLabel2.fill = am4core.color('#00E676')
                    })


                    // Add cursor
                    this.chart.cursor = new am4charts.RadarCursor()

                    // this.chart.legend = new am4charts.Legend();
                    // let markerTemplate = this.chart.legend.markers.template;
                    // markerTemplate.width = 10;
                    // markerTemplate.height = 10;
                    // this.chart.legend.labels.template.text = "[font-size: 11px]{value}:[/]"
                    
                    localStorage.setItem('my_orders_status_'+this.$store.getters.getProfile.id, JSON.stringify(true))
                    this.loading = false        
                }, response => {
                    // error callback
                })

            }
        },

        beforeDestroy() {
            if (this.chart && !_.isEmpty(this.chart)) {
                this.chart.dispose()
            }
        },
    }
</script>
<style>
    .v-toolbar__content {
        padding-left: 8px !important;
    }
</style>